module.exports = __webpack_public_path__ + "static/media/instapage7.706958e3.png";